import React from "react";
import { Modal, Spin } from "antd";
import last from 'lodash/last';
import { Storage } from "aws-amplify";

export default class Preview extends React.Component {
  state = {
    url: null
  };
  componentDidMount() {
    Storage.get(this.props.fileKey, { level: "private" }).then(url =>
      this.setState({ url })
    );
  }

  render() {
    const { fileKey  } = this.props;
    const filename = last(fileKey.split('/'));
    return (
      <Modal visible footer={null} onCancel={this.props.onClose} width="80%" title={filename}>
        <Spin spinning={!this.state.url}>
          <img alt="preview" style={{ width: "100%" }} src={this.state.url} />
        </Spin>
      </Modal>
    );
  }
}
